const countdowns = new Set();
let timerId = null;

function getRemainingSeconds(element) {
  const availableFrom = Number(element.dataset.availableFrom || 0);
  if (!availableFrom) return 0;

  return Math.max(0, availableFrom - Math.floor(Date.now() / 1000));
}

function setText(element, selector, value) {
  const target = element.querySelector(selector);
  if (target) target.textContent = String(value);
}

function revealPurchaseUi(launchId) {
  if (!launchId) return;

  document
    .querySelectorAll("[data-product-launch-purchase]")
    .forEach((element) => {
      if (element.dataset.productLaunchPurchase !== launchId) return;

      element.hidden = false;
      element.removeAttribute("aria-hidden");
    });

  document
    .querySelectorAll("[data-product-launch-hide-on-release]")
    .forEach((element) => {
      if (element.dataset.productLaunchHideOnRelease !== launchId) return;

      element.hidden = true;
    });
}

function completeCountdown(element) {
  const launchId = element.dataset.productLaunchId;

  element.hidden = true;
  element.dispatchEvent(
    new CustomEvent("product-launch:released", {
      bubbles: true,
      detail: { launchId },
    }),
  );
  revealPurchaseUi(launchId);
  countdowns.delete(element);
}

function updateCountdown(element) {
  const remaining = getRemainingSeconds(element);

  if (remaining <= 0) {
    completeCountdown(element);
    return;
  }

  const days = Math.floor(remaining / 86400);
  const hours = Math.floor((remaining % 86400) / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;

  setText(element, "[data-product-launch-days]", days);
  setText(element, "[data-product-launch-hours]", hours);
  setText(element, "[data-product-launch-minutes]", minutes);
  setText(element, "[data-product-launch-seconds]", seconds);
}

function tick() {
  countdowns.forEach(updateCountdown);

  if (countdowns.size === 0 && timerId) {
    window.clearInterval(timerId);
    timerId = null;
  }
}

function initCountdowns(root = document) {
  root
    .querySelectorAll("[data-product-launch-countdown]")
    .forEach((element) => {
      if (countdowns.has(element)) return;

      countdowns.add(element);
      updateCountdown(element);
    });

  if (countdowns.size > 0 && !timerId) {
    timerId = window.setInterval(tick, 1000);
  }
}

initCountdowns();

document.addEventListener("shopify:section:load", (event) => {
  initCountdowns(event.target);
});

document.addEventListener("product-card:rerender", () => {
  initCountdowns();
});

new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    mutation.addedNodes.forEach((node) => {
      if (node instanceof HTMLElement) {
        initCountdowns(node);
      }
    });
  }
}).observe(document.documentElement, { childList: true, subtree: true });
